export var COUNTRY_CANADA = 'CAN';